import React, { useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  IconButton,
  Tooltip,
  CircularProgress,
} from "@mui/material";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import axios from "axios";
import { getFilterDetails } from "store/api";
import { addFilterOptionProduct } from "store/api"; // your productId

export default function FilterList ({ filters, productId, getProductDetails }) {
  const [open, setOpen] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [processingId, setProcessingId] = useState(null);

  const handleOpenOptions = async filter => {
    setSelectedFilter(filter);
    setOpen(true);
    setLoading(true);

    try {
      const res = await getFilterDetails({ filterId: filter.filterId });
      const fetchedOptions = res.data.filterOptions || [];

      const activeOptionIds = filter?.options?.map(o => o.filterOptionId);

      const enrichedOptions = fetchedOptions.map(opt => ({
        ...opt,
        isActive: activeOptionIds?.includes(opt.filterOptionId) || false,
      }));

      setOptions(enrichedOptions);
    } catch (err) {
      console.error("Error fetching filter details:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleToggleOption = async option => {
    try {
      setProcessingId(option.filterOptionId);
      await addFilterOptionProduct({
        productId,
        filterOptionId: option.filterOptionId,
        isActive: !option.isActive,
      });
      getProductDetails();
      setSelectedFilter({});
      setOpen(false);
      setLoading(false);
    } catch (err) {
      console.error("Failed to update option:", err);
    } finally {
      setProcessingId(null);
    }
  };

  return (
    <Box
      sx={{
        border: "1px solid #ddd",
        borderRadius: "8px",
        marginTop: "10px",
        padding: "12px",
        color: "#344767",
      }}
    >
      <Typography variant='h6'>Filters</Typography>

      {filters.map(filter => (
        <Paper
          key={filter.filterId}
          sx={{
            padding: 2,
            marginTop: 2,
            background: "none",
            color: "#344767",
            position: "relative",
          }}
        >
          <Typography variant='subtitle1' sx={{ fontWeight: 600, fontSize: "18px" }}>
            {filter.name}
          </Typography>
          {filter?.options?.map((option, index) => (
            <li key={index} style={{ fontSize: "16px" }}>
              {option?.value}
            </li>
          ))}
          <Button
            variant='contained'
            color='success'
            onClick={() => handleOpenOptions(filter)}
            sx={{
              marginTop: 1,
              position: "absolute",
              top: "0px",
              right: "10px",
              padding: "4px 8px",
            }}
          >
            Manage Filter
          </Button>
        </Paper>
      ))}

      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth='sm'>
        <DialogTitle>Manage Options for {selectedFilter?.name}</DialogTitle>
        <DialogContent>
          {loading ? (
            <CircularProgress />
          ) : options.length === 0 ? (
            <Typography>No options available.</Typography>
          ) : (
            <List>
              {options.map(opt => (
                <ListItem
                  key={opt.filterOptionId}
                  sx={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Typography>
                    {opt.value || "No Value"}
                    <span
                      style={{
                        color: opt.isActive ? "green" : "red",
                        fontSize: "12px",
                        marginLeft: 8,
                      }}
                    >
                      [{opt.isActive ? "Active" : "Inactive"}]
                    </span>
                  </Typography>
                  <Tooltip title={opt.isActive ? "Remove from Product" : "Add to Product"}>
                    <span>
                      <IconButton
                        onClick={() => handleToggleOption(opt)}
                        disabled={processingId === opt.filterOptionId}
                        color={opt.isActive ? "error" : "primary"}
                      >
                        {processingId === opt.filterOptionId ? (
                          <CircularProgress size={18} />
                        ) : opt.isActive ? (
                          <DeleteRoundedIcon />
                        ) : (
                          <AddRoundedIcon />
                        )}
                      </IconButton>
                    </span>
                  </Tooltip>
                </ListItem>
              ))}
            </List>
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
}
